module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/da53aea8fe31e734f1e2e9e20c517291.png";